/* Sia Bella launch bundle codes: WELCOME10 (1 item), WELCOME15 (2+ items), WELCOME20 (3+ items).
 *
 * The codes stay manual, so a shopper opts in by applying one. From then on this keeps the cart on
 * the code that matches its item count: going from 2 items to 1 swaps WELCOME15 for WELCOME10
 * instead of the discount silently dropping, and adding a third item steps up to WELCOME20.
 * A cart carrying any other code (FNF10, Mom20, ...) is never touched.
 *
 * Applying the code on the cart also means shoppers reach checkout with the discount already in
 * place, rather than typing it into Shopify's checkout (where some iPhones showed a white screen).
 *
 * Loaded by snippets/sb-launch-bundles.liquid and snippets/sb-cart-perks.liquid; safe to include
 * more than once. Keep TIERS in step with the discount codes in admin and the ladder in
 * sb-launch-bundles.liquid.
 */
(function () {
  if (window.SbBundles) return;

  var TIERS = [
    { min: 3, code: 'WELCOME20', pct: 20 },
    { min: 2, code: 'WELCOME15', pct: 15 },
    { min: 1, code: 'WELCOME10', pct: 10 }
  ];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function tierFor(count) {
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }
  function isBundleCode(code) {
    return /^WELCOME(10|15|20)$/i.test(code || '');
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function onCartPage() {
    return /\/cart\/?$/.test(location.pathname);
  }
  // The bundle code that is actually discounting this cart, if any.
  function appliedBundle(cart) {
    var hit = null;
    (cart.discount_codes || []).forEach(function (d) {
      if (d.applicable && isBundleCode(d.code)) hit = d.code.toUpperCase();
    });
    return hit;
  }

  // Replace the cart's codes with `code`, then refresh what is on screen. Dawn's drawer only
  // re-renders on its own events, so the drawer's inner markup is swapped from the section HTML
  // the same way Dawn does after a quantity change; the cart page simply reloads.
  function setCode(code) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: ['cart-drawer'], sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var took = (state.discount_codes || []).some(function (d) { return (d.code || '').toUpperCase() === code; });
        if (onCartPage()) {
          // Reload only when the switch really happened, so a refused code can never loop.
          if (took) location.reload();
          return state;
        }
        var html = state && state.sections && state.sections['cart-drawer'];
        if (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer .drawer__inner');
          var current = document.querySelector('#CartDrawer .drawer__inner');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('sb:bundle-code', { detail: { code: code } }));
        return state;
      });
  }

  // Opt in: put the right tier for the current cart on it. Used by the product page bundle bars.
  function apply() {
    return getCart().then(function (cart) {
      var tier = tierFor(Math.max(cart.item_count, 1));
      return setCode(tier.code).then(function () { return tier; });
    });
  }

  // After any cart change: if the cart has opted in (only bundle codes on it), keep it on the
  // tier for its item count.
  function sync() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart()
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        var tier = tierFor(cart.item_count);
        if (!tier || !codes.length) return;
        for (var i = 0; i < codes.length; i++) {
          if (!isBundleCode(codes[i])) return;
        }
        if (codes.length === 1 && codes[0].toUpperCase() === tier.code) return;
        return setCode(tier.code);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  window.SbBundles = {
    tiers: TIERS,
    tierFor: tierFor,
    isBundleCode: isBundleCode,
    appliedBundle: appliedBundle,
    getCart: getCart,
    apply: apply,
    sync: sync
  };

  // The cart's "Apply code" / "Switch code" links (sb-cart-perks) are plain /discount/CODE links.
  // With this script they apply in place, so the drawer stays open; if that fails, the link runs.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-sb-apply]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var label = link.textContent;
    link.textContent = 'Applying…';
    apply().then(
      function () { if (document.contains(link)) link.textContent = label; },
      function () { location.href = link.href; }
    );
  });

  function start() {
    // Dawn's pubsub (assets/pubsub.js, constants.js) announces every add, quantity change and removal.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 150); });
    }
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();